import React from 'react';

const IconPerson = props => (<svg viewBox="0 0 20 20" width="20px" height="20px" {...props}>
  <path d="M9.812 10.777L9.812 10.777c-2.743 0-4.967 2.122-4.967 4.738v1.463h9.933v-1.463C14.777 12.898 12.555 10.777 9.812 10.777 z" />
  <path d="M9.812 9.941c1.734 0 3.141-1.341 3.141-2.996c0-1.655-1.406-2.996-3.141-2.996S6.671 5.291 6.671 6.945 C6.671 8.6 8.077 9.941 9.812 9.941z" />
</svg>);

export default IconPerson;
